<ngx-spinner bdOpacity=0.9 size="medium" color="#C00000" type="ball-clip-rotate" [fullScreen]="true" name="my-spinner">{{utilsService.missatgeSpinner}}</ngx-spinner>

<app-header></app-header>

<main>
	<router-outlet></router-outlet>
</main>

<app-footer></app-footer>